/*
 * @Author: your name
 * @Date: 2020-02-04 16:07:05
 * @LastEditTime: 2020-04-16 14:13:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \h5_jifen_mall\src\assets\http.js
 */
import axios from 'axios'
import { Toast } from 'vant'
import urlconfig from '@/config.js'
import { Dialog } from 'vant'

var errTips = 1
// 封装axios请求
class Http {
  constructor(el) {
    //  每次上传测试和正式记得打开对应的接口地址

    this.Domain = urlconfig.Domain // 注意： 测试接口地址
    this.baseUrl = urlconfig.loginDomain // 注意： 测试接口地址（登录）

    // this.Domain = "https://hot.daominyoupin.com/";  //正式 接口地址
    // this.baseUrl = "https://sapi.daominyoupin.com/"; // 正式 接口地址 （登录）
  }
  require(options, flag, isVideo) {
    if (!options.api) throw new Error('api 不能为空')
    if (!options.param) {
      options.param = {}
    } //param==空  默认赋值一下
    if (!options.methods) {
      options.methods = 'POST'
    } //不传递方法默认为POST
    let timer = Date.parse(new Date()) / 1000 //时间戳 以秒为单位
    let tobj = options.param
    if (!flag) {
      tobj.store_id = localStorage.getItem('store_id')
      // tobj.store_id = 4326648
      // tobj.store_id = 5295806
    }
    var params = {
      content: {
        base: {
          time: timer,
          source: 4,
          equipment: 'b2bwap',
          token: localStorage.getItem('token')
            ? localStorage.getItem('token')
            : '',
          // token: 'FE457CAC6BEBEF1C1EFC11ED5E5A2B4E',
          // token: '57D015298DD85E0EDF715BD8D98A565F',
          version: 'v3.1.2',
        },
        data: tobj,
      },
      dataType: 'json',
      lock: '',
      time: timer,
      app_key: 'b371659b-f315-493d-a43c-881999a502ef',
    }
    let headType = ''
    headType = flag ? 'application/x-www-form-urlencoded' : 'application/json'
    if (isVideo) {
      //二进制上传视频
      headType = 'multipart/form-data'
    }
    // console.log(JSON.stringify(params))
    return new Promise((resolve, reject) => {
      return axios({
        method: options.methods, //get post
        url: `${this.Domain}${options.api}`, // 请求地址
        data: flag ? JSON.stringify(params) : params, //请求数据
        headers: {
          'Content-Type': headType,
        },
      }).then(
        (response) => {
          // console.log(response,'-=-=-=-=333333333')

          if (response.data.status == 60001) {
            // alert(response.data.status)
            // console.log('qwq32',response.data.status)

            if (errTips == 1) {
              errTips = 2
              console.log(errTips)
              setTimeout(() => {
                Dialog.confirm({
                  message: response.data.msg,
                  showConfirmButton: false,
                  showCancelButton: false
                })
                  .then(() => {
                    // on confirm
                  })
                  .catch(() => {
                    // on cancel
                  })
                errTips = 1
              }, 1000);
              console.log('qwq32', response.data.status)
            }

          }

          if (response.data.status == -10006) {
            // 清除本地緩存
            // localStorage.clear();
            localStorage.setItem('wx', '')
            Toast('token已失效，请重新登录')
            setTimeout(() => {
              //  每次上传测试和正式记得打开对应的接口地址
              // window.location.href= `${urlconfig.goPath}login` // 注意：测试访问域名
            }, 2000)
          }
          resolve(response.data)
        },
        (error) => {
          resolve(error)
        }
      )
    })
  }

  upLoad(api, options) {
    console.log(api.api, '9898', api.param)
    return new Promise((resolve, reject) => {
      return axios({
        method: 'POST', //get post
        url: api.api, // 请求地址
        data: api.param,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
export default Http
